import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/address/address.service.ts
 * Registered via downgradeInjectable in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 */
export { AddressService } from '@ng/core/address/address.service';

export const AddressServiceModule = angular.module('acme.common.service.address', []).name;
